import { useTransition, animated, config } from 'react-spring';
import { MountProps, ToggleProps } from './types';

export function Mount(props: MountProps) {
    const transitions = useTransition(props.show, {
      from: { opacity: 0 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
      reverse: props.show,
      delay: 200,
      config: config.molasses
    });

    return transitions(
      (styles, item) => item &&
        <animated.div style={styles}>
            {props.content}
        </animated.div>
    );
}

export function Toggle(props: ToggleProps) {
  const transitions = useTransition(props.toggle, {
    from: { position: 'absolute', opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    reverse: props.toggle,
    delay: 200,
    config: config.molasses,
  });

  return transitions(({ opacity }, item) =>
    item ? (
      <animated.div
        style={{
          opacity: opacity.to({ range: [0.0, 1.0], output: [0, 1] }),
        }}>
        {props.content1}
      </animated.div>
    ) : (
      <animated.div
        style={{
          opacity: opacity.to({ range: [1.0, 0.0], output: [1, 0] }),
        }}>
        {props.content2}
      </animated.div>
    )
  );
}